import React from 'react'
import ContentContainer from './ContentContainer'
import * as ContentList from './ContentList'
import * as CacheUtils from '../util/CacheUtils'
import * as DataUtils from '../util/DataUtils'
import * as TypeUtils from '../util/TypeUtils'
//import { Link } from 'react-router-dom'

export default class ContentPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  componentDidMount() {
    this.setup(this.props)
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.match.params.slug !== this.props.match.params.slug) {
      this.setup(nextProps)
    }
    return true
  }
  setup(props) {
    if (TypeUtils.isObject(props)) {
      const match = props.match
      if (TypeUtils.isObject(match)) {
        const params = match.params
        if (TypeUtils.isObject(params)) {
          const type = params.type
          if (TypeUtils.isNonEmptyString(type)) {
            const slug = params.slug
            if (TypeUtils.isNonEmptyString(slug)) {
              // get slugs from cache
              const slugsFileName = `${type}${ContentList.SLUGS}`
              const slugs = CacheUtils.get(slugsFileName)
              if (TypeUtils.isNonEmptyArray(slugs)) {
                const entry = slugs.find(e=>e[DataUtils.SLUG]===slug)
                if (TypeUtils.isObject(entry)) {
                  const id = entry[DataUtils.ID]
                  this.load(type, id)
                }
              } else {
                // slugs not cache yet, read from index
                this.fetchSlugs(type, (slugs)=>{
                  if (TypeUtils.isNonEmptyArray(slugs)) {
                    // cache slugs
                    CacheUtils.set(slugsFileName, slugs)
                    const entry = slugs.find(e=>e[DataUtils.SLUG]===slug)
                    if (TypeUtils.isObject(entry)) {
                      const id = entry[DataUtils.ID]
                      this.load(type, id)
                    }
                  }
                })
              }
            } else {
              const id = params.id
              this.load(type, id)
            }
          }
        }
      }
    }
  }
  fetchSlugs(type, cb) {
    if (TypeUtils.isNonEmptyString(type)) {
      const dataPath = `/data`
      const indexesPath = `${dataPath}/indexes`
      const fileName = `${type}${DataUtils._}${DataUtils.SLUG}.json`
      const filePath = `${indexesPath}/${fileName}`
      DataUtils.fetchArray(filePath, data=>{
        const slugs = data
        if (TypeUtils.isNonEmptyArray(slugs)) {
          if (typeof(cb)==='function') {
            cb(slugs)
          }
        }
      }, this.cbe)
    }
  }
  load(type, id, cb) {
    if (TypeUtils.isNonEmptyString(id) && TypeUtils.isNonEmptyString(id)) {
      const dataPath = `/data`
      const contentsPath = `${dataPath}/contents`
      const fileName = `${id}.json`
      const filePath = `${contentsPath}/${type}/${fileName}`
      DataUtils.fetchObject(filePath, data=>{
        const content = data
        if (TypeUtils.isObject(content)) {
          this.setState({content:content},()=>{
            this.loadPrevNext()
            if (typeof(cb)==='function') {
              cb()
            }
          })
        }
      }, this.cbe)
    }
  }
  loadPrevNext(cb) {
    const content = this.state.content
    if (TypeUtils.isObject(content)) {
      const id = content[DataUtils.ID]
      const type = content[DataUtils.TYPE]
      if (TypeUtils.isNonEmptyString(id) && TypeUtils.isNonEmptyString(type)) {
        // get slugs from cache
        const slugsFileName = `${type}${ContentList.SLUGS}`
        const slugs = CacheUtils.get(slugsFileName)
        if (TypeUtils.isNonEmptyArray(slugs)) {
          const index = slugs.findIndex(e=>e[DataUtils.ID]===id)
          if (index>0) {
            // load prev
            const prev = slugs[index-1]
            if (TypeUtils.isObject(prev)) {
              prev[DataUtils.TYPE] = type
              this.setState({prev:prev})
            }
          } else {
            this.setState({prev:undefined})
          }
          if (index+1<slugs.length) {
            // load next
            const next = slugs[index+1]
            if (TypeUtils.isObject(next)) {
              next[DataUtils.TYPE] = type
              this.setState({next:next})
            }
          } else {
            this.setState({next:undefined})
          }
        } else {
          // get slugs from files
          this.fetchSlugs(type, (slugs)=>{
            if (TypeUtils.isNonEmptyArray(slugs)) {
              // cache slugs
              CacheUtils.set(slugsFileName, slugs)
              const index = slugs.findIndex(e=>e[DataUtils.ID]===id)
              if (index>0) {
                // load prev
                const prev = slugs[index-1]
                if (TypeUtils.isObject(prev)) {
                  prev[DataUtils.TYPE] = type
                  this.setState({prev:prev})
                }
              } else {
                this.setState({prev:undefined})
              }
              if (index+1<slugs.length) {
                // load next
                const next = slugs[index+1]
                if (TypeUtils.isObject(next)) {
                  next[DataUtils.TYPE] = type
                  this.setState({next:next})
                }
              } else {
                this.setState({next:undefined})
              }
            }
          })
        }
      }
    }
  }
  cbe=(e)=>{
    if (TypeUtils.isObject(e)) {
      this.setState({message:{
        type: 'danger',
        value: `Something is not right! ${e.message}`,
      }})
    }
  }
  render() {
    return (
      <div className="container mb-3">
        {
          TypeUtils.isObject(this.state.content)&&
          <ContentContainer
            {...this.state.content}
            prev={this.state.prev}
            next={this.state.next}
            location={this.props.location}
          />
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentPage.js